import common from "./common";
import app from "./app";
import settings from "./settings";
import userSettings from "./userSettings";
import settingsPages from "./settingsPages";
import cart from "./cart";
import catalogue from "./catalogue";
import articleTile from "./articleTile";
import checkout from "./checkout";
import dialogs from "./dialogs";
import orderHistory from "./orderHistory";
import store from "./store";
import dtoLabels from "./dtoLabels";

export default {
	common,
	app,
	settings,
	userSettings,
	settingsPages,
	cart,
	catalogue,
	articleTile,
	checkout,
	dialogs,
	orderHistory,
	store,
	dtoLabels,
};
